export const technology = [
    {
        img: "/images/javascript.png",
        name: "JavaScript / ES6",
    },
    {
        img: "/images/html5-2.png",
        name: "HTML5",
    },
    {
        img: "/images/css3.jpeg",
        name: "CSS3",
    },
    {
        img: "/images/React.png",
        name: "React",
    },
    {
        img: "/images/angular.png",
        name: "Angular",
    },
    {
        img: "/images/jquery.png",
        name: "jQuery",
    },
    {
        img: "/images/git.png",
        name: "Git",
    },
    {
        img: "/images/github.jpeg",
        name: "Github",
    },
    {
        img: "/images/node.png",
        name: "Node.Js",
    },
     {
        img: "/images/netlify.png",
        name: "Netlify",
    },
    {
        img: "/images/wordpress.png",
        name: "Word Press",
    },
    {
        img: "/images/shopify.png",
        name: "Shopify",
    },
    {
        img: "/images/googleanalytics.png",
        name: "Google Analytics",
    },
    {
        img: "/images/seo.jpeg",
        name: "Search Engine Optimization",
    }, {
        img: "/images/mx.png",
        name: "Mendix",
    }
];